export default "__VITE_ASSET__7b9735bd__"